module.exports = __webpack_public_path__ + "static/media/big-neon-sketch-1.66755d9a.jpg";